// extracted by mini-css-extract-plugin
export default {"fileInput":"UploadWidget_fileInput__+X1Pk","uploadWidget":"UploadWidget_uploadWidget__T-gh2","error":"UploadWidget_error__1EOu3"};